export * from './decoration-pixelization-list.component';
